import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import moment from 'moment';

import StarRating from '../../StarRating';
import Link from '../../../components/Link';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';

import messages from '../../../locale/messages';
import { debounce } from '../../../helpers/debounce';
import { updateReviewStatus } from '../../../actions/siteadmin/UserReview/manageReviews';

import withStyles from 'isomorphic-style-loader/withStyles';

import s from './UserReviewsManagement.css';

function UserReviewsManagement(props) {
    const { userReviews: { refetch, getReviewsDetails, loading }, setStateVariable, currentPage, searchList, updateReviewStatus } = props;
    const { formatMessage } = useIntl();

    const paginationData = (currentPage) => {
        let variables = { currentPage };
        setStateVariable(variables);
        refetch(variables);
    }

    const handleSearchChange = debounce((searchList) => {
        let variables = {
            currentPage: 1,
            searchList,
        };
        setStateVariable(variables);
        refetch(variables);
    }, 250)


    const thead = () => {
        return [
            { data: formatMessage(messages.listId) },
            { data: formatMessage(messages.reviewContentLabel) },
            { data: formatMessage(messages.adminListTitle) },
            { data: formatMessage(messages.reservationConfirmCode) },
            { data: formatMessage(messages.CheckInDate) },
            { data: formatMessage(messages.CheckOutDate) },
            { data: formatMessage(messages.SenderLabel) },
            { data: formatMessage(messages.receiverLabel) },
            { data: formatMessage(messages.ratingReviewLabel) },
            { data: formatMessage(messages.reviewStatusLabel) },
            { data: formatMessage(messages.actionLabel) }
        ]
    }

    const tbody = () => {
        return getReviewsDetails?.results?.map(function (value, key) {
            let content = value.reviewContent, reviewContent = content.slice(0, 10), dots = '...';
            let isContent = content.length > 10, title, confirmationCode, checkInDate, checkOutDate;
            let hostName = value?.userData?.firstName, guestName = value?.authorData?.firstName;
            let hostProfileId = value?.userData?.profileId, guestProfileId = value?.authorData?.profileId;
            title = value?.listData?.title ? value.listData.title : formatMessage(messages.dataMissing);
            confirmationCode = value?.singleReservationData?.confirmationCode ? value.singleReservationData.confirmationCode : '';
            checkInDate = value?.singleReservationData?.checkIn ? moment(value.singleReservationData.checkIn).format('MM/DD/YYYY') : '';
            checkOutDate = value?.singleReservationData?.checkOut ? moment(value.singleReservationData.checkOut).format('MM/DD/YYYY') : '';

            return {
                id: key,
                data: [
                    { data: value?.listId },
                    { data: isContent ? reviewContent?.concat(dots) : reviewContent },
                    {
                        data: value?.listData?.title ? <a href={"/rooms/" + value?.listId} target="_blank">{title}</a> : title
                    },
                    { data: confirmationCode },
                    { data: checkInDate },
                    { data: checkOutDate },
                    {
                        data: <a href={"/users/show/" + guestProfileId} target="_blank">{guestName}</a>
                    },
                    {
                        data: <a href={"/users/show/" + hostProfileId} target="_blank">{hostName}</a>
                    },
                    {
                        data: <StarRating value={value?.rating} name={'review'} starCount={5} />
                    },
                    {
                        data: <select value={value?.isAdminEnable ? 'enable' : 'disable'} onChange={(e) => updateReviewStatus(value?.id, e?.target?.value, currentPage, searchList)}>
                            <option value={'enable'}>{formatMessage(messages.enabledLabel)}</option>
                            <option value={'disable'}>{formatMessage(messages.disabledLabel)}</option>
                        </select>
                    },
                    {
                        data: <Link to={"/siteadmin/management-reviews/" + value?.id}>
                            <FormattedMessage {...messages.editLabel} />
                        </Link>
                    }
                ]
            }
        })
    }

    return (
        <div>
            <CommonTable
                title={formatMessage(messages.manageReviwes)}
                thead={thead}
                tbody={() => tbody()}
                isSearch
                handleSearch={(e) => handleSearchChange(e?.target?.value)}
                loading={loading}
            />
            {getReviewsDetails?.results?.length > 0 && <div>
                <CustomPagination
                    total={getReviewsDetails?.count}
                    currentPage={currentPage}
                    defaultCurrent={1}
                    defaultPageSize={10}
                    change={paginationData}
                    paginationLabel={formatMessage(messages.reviews)}
                    isScroll
                />
            </div>
            }
        </div>
    );
}

const mapState = (state) => ({
});

const mapDispatch = {
    updateReviewStatus
};

UserReviewsManagement.propTypes = {
    data: PropTypes.array,
    editUser: PropTypes.func,
    title: PropTypes.string.isRequired,
    updateReviewStatus: PropTypes.func.isRequired,
};

export default compose(
    injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch),
)(UserReviewsManagement);